import { atom } from "recoil";

export enum EWidgetProductSettingsTabs {
  PRODUCT_MANAGMENT = 0,
  SHIPMENTS_SETTING = 1,
  PRICING_SETTING = 2,
  ADD_PRODUCT = 3,
}

export const selectedProductsTabState = atom<number>({
  key: "selectedProductsTabState",
  default: 0,
});

/** Bumped after product mutations so the management grid refetches fresh data. */
export const productsListRefreshTokenState = atom<number>({
  key: "productsListRefreshTokenState",
  default: 0,
});
